module.exports = __webpack_public_path__ + "img/scopesi.b39fb6e0.png";